/** Параметры воспроизведения аудио. */
export interface AudioPlayOptions {
  volume?: number;
  loop?: boolean;
}

/** Абстракция аудио-движка. */
export interface AudioAdapter {
  preload(id: string, url: string): Promise<void>;
  play(id: string, opts?: AudioPlayOptions): void;
  stop(id: string): void;
  setMuted(muted: boolean): void;
}

/** Stub — реальная реализация подключается с аудио-контентом в отдельной итерации. */
export class WebAudioAdapter implements AudioAdapter {
  private muted = false;

  /** Заранее загружает аудио-файл (no-op пока нет контента). */
  async preload(_id: string, _url: string): Promise<void> {
    // noop until audio content arrives
  }

  /** Воспроизводит звук по id (no-op пока нет контента). */
  play(_id: string, _opts: AudioPlayOptions = {}): void {
    // noop
  }

  /** Останавливает воспроизведение звука. */
  stop(_id: string): void {
    // noop
  }

  /** Включает/выключает глобальный mute. */
  setMuted(muted: boolean): void {
    this.muted = muted;
  }

  /** Текущий mute-статус. */
  isMuted(): boolean {
    return this.muted;
  }
}
